<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Student Scholarship</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Student Scholarship</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="notfound thank-you ptb--60">
  <div class="container">
    <div class="row justify-content-center align-items-center text-center">
      <div class="col-12 col-lg-6">
        <div class="notfound-404">
          <h2>Thank You</h2>
        </div>
        <p class="text-center">Thank you for submitting your query and we will reply to you very soon.</p>
        <h3 class="mt-2 fw-bold">Please go back to the homepage.</h3>
        <a routerLink="/" class="cmn-button mt-3">Home Page</a>
      </div>
    </div>
  </div>
</section>
